import { Select, SelectProps } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { supportedLngs } from "../../../@resource-interfaces/i18nModuleAugment"

const languageLabel: Record<string, string> = {
  en: "English",
  de: "Deutsch",
}

const selectProps: SelectProps = {
  size: "sm",
  px: "sm",
  comboboxProps: {
    withinPortal: false, // fixes problem with select inside of menu dropdowns
  },
}

const options = supportedLngs.map((language: string) => ({
  value: language,
  label: languageLabel[language] ?? language,
}))

export function LanguageSelect() {
  const { i18n } = useTranslation()
  const handleChange = (val: string | null) => {
    if (val) {
      i18n.changeLanguage(val)
    }
  }

  return (
    <Select
      {...selectProps}
      value={i18n.language}
      onChange={handleChange}
      data={options}
    />
  )
}
